import * as yup from 'yup';
import _get from 'lodash/get';
import _map from 'lodash/map';
import _values from 'lodash/values';

import { Row, RenderConfig, TextInput, AssetUploadInputOnS3, ASSET_TYPE, SelectInput } from 'commons-ui';
import { BLOCK_REASONS, MARK_FRAUD_OPTIONS } from './constants';

const FORM_FIELD_KEYS = {
	SELECTED_REASON: 'selectedReason',
	OTHER_REASON: 'otherReason',
	REASON: 'reason',
	ATTACHMENTS: 'attachments',
	FRESHDESK_ID: 'freshdeskTicketId',
	MARK_FRAUD: 'markFraud'
};

export const FORM_FIELD_KEYS_USER_LEVEL_UPDATE = {
	USER_LEVEL: 'userLevel'
};

const otherReasonDependencyResolver = (props: any, dependencyValues: any) => {
	const selectedReason = _get(dependencyValues, '0');
	const { disabled } = props;

	if (selectedReason === BLOCK_REASONS.OTHER && disabled) {
		return { disabled: false };
	}
	if (selectedReason !== BLOCK_REASONS.OTHER && !disabled) {
		return { disabled: true };
	}
	return null;
};

export const validationSchemaUnblock = yup.object().shape({
	reason: yup
		.string()
		.matches(/^[0-9a-zA-Z.,\s]{0,100}$/, 'Reason should only contains alphanumeric characters or space or , or .')
		.required('Reason is a required field'),
	freshdeskTicketId: yup
		.string()
		.required('freshdeskTicketId is a required field, If no Freshdesk Ticket exists then please use Jira Ticket ID')
});

export const validationSchemaUpdateUserFraudStatus = yup.object().shape({
	reason: yup
		.string()
		.matches(/^[0-9a-zA-Z.,\s]{0,100}$/, 'Reason should only contains alphanumeric characters or space or , or .')
		.required('Reason is a required field'),
	freshdeskTicketId: yup
		.string()
		.required('freshdeskTicketId is a required field, If no Freshdesk Ticket exists then please use Jira Ticket ID')
});

export const validationSchemaBlock = yup.object().shape({
	selectedReason: yup.string().required('Reason is a required field'),
	otherReason: yup.string().when(['selectedReason'], {
		is: BLOCK_REASONS.OTHER,
		then: yup
			.string()
			.matches(/^[0-9a-zA-Z.,\s]{0,100}$/, 'Reason should only contains alphanumeric characters or space or , or .')
			.required('Reason is a required field')
	}),
	freshdeskTicketId: yup
		.string()
		.required('freshdeskTicketId is a required field, If no Freshdesk Ticket exists then please use Jira Ticket ID')
});

export const validationSchemaUserLevelUpdate = yup.object().shape({
	userLevel: yup.number().required('User Level is a required field')
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.SELECTED_REASON]: new RenderConfig()
		.setName('selectedReason')
		.setLabel('Reason')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			options: _map(_values(BLOCK_REASONS), (reason) => ({ id: reason, label: reason }))
		}),
	[FORM_FIELD_KEYS.OTHER_REASON]: new RenderConfig()
		.setName('otherReason')
		.setLabel('Other Reason')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			dependencies: ['selectedReason'],
			dependencyResolver: otherReasonDependencyResolver
		}),
	[FORM_FIELD_KEYS.MARK_FRAUD]: new RenderConfig()
		.setName('markFraud')
		.setLabel('Mark Status Fraud')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: _map(_values(MARK_FRAUD_OPTIONS), (option) => ({ id: option, label: option }))
		}),
	[FORM_FIELD_KEYS.REASON]: new RenderConfig()
		.setName('reason')
		.setLabel('Reason')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.FRESHDESK_ID]: new RenderConfig()
		.setName('freshdeskTicketId')
		.setLabel('Freshdesk Ticket Id / Jira Ticket Id')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.ATTACHMENTS]: new RenderConfig()
		.setName('attachments')
		.setLabel('Attachments')
		.setRenderer(AssetUploadInputOnS3)
		.setRenderProps({ isEditable: { create: true, edit: true }, assetType: ASSET_TYPE.MEDIA_PRIVATE, multiple: true })
};

export const FORM_LAYOUT_CONFIG_USER_LEVEL_UPDATE = [new Row(FORM_FIELD_KEYS_USER_LEVEL_UPDATE.USER_LEVEL)];

export const FORM_LAYOUT_CONFIG_BLOCK = [
	new Row(FORM_FIELD_KEYS.SELECTED_REASON),
	new Row(FORM_FIELD_KEYS.OTHER_REASON),
	new Row(FORM_FIELD_KEYS.MARK_FRAUD),
	new Row(FORM_FIELD_KEYS.FRESHDESK_ID),
	new Row(FORM_FIELD_KEYS.ATTACHMENTS)
];

export const FORM_LAYOUT_CONFIG_UNBLOCK = [
	new Row(FORM_FIELD_KEYS.REASON),
	new Row(FORM_FIELD_KEYS.FRESHDESK_ID),
	new Row(FORM_FIELD_KEYS.ATTACHMENTS)
];

export const FORM_LAYOUT_CONFIG_UPDATE_USER_FRAUD_STATUS = [
	new Row(FORM_FIELD_KEYS.REASON),
	new Row(FORM_FIELD_KEYS.FRESHDESK_ID),
	new Row(FORM_FIELD_KEYS.ATTACHMENTS)
];
